import { gql } from '@apollo/client';

/**
 * 当前登录用户可见的看板与分组（后端已按可见范围过滤）。
 *
 * **不含 embedUrl**：嵌入 URL 是免登凭证，几百个看板时整批下发既让菜单响应大一个数量级，
 * 又会把所有分享链接落进 localStorage。真要打开某个看板时再用 `DATA_PORTAL_EMBED_URL` 单条取。
 */
export const GET_MY_DATA_PORTAL_MENU = gql`
  query MyDataPortalMenu {
    myDataPortalMenu {
      pages {
        pageKey
        nameEn
        nameZh
        nameEs
        groupId
        icon
        sortOrder
        openMode
        portalCode
      }
      groups {
        id
        nameEn
        nameZh
        nameEs
        sortOrder
        enabledPageCount
        portalCode
      }
      portalCodes
      canConfig
    }
  }
`;

/** 打开某个看板时按需取它的完整嵌入 URL；后端仍会校验可见性，不可见返回 null */
export const DATA_PORTAL_EMBED_URL = gql`
  query DataPortalEmbedUrl($pageKey: String!) {
    dataPortalEmbedUrl(pageKey: $pageKey)
  }
`;

/** 灰度开关查询：复用既有的通用配置批量接口，不新增专用端点 */
export const BATCH_GET_CONFIG_ENABLE = gql`
  query BatchGetConfigEnable($configKeys: [String!]!) {
    batchGetConfigEnable(configKeys: $configKeys) {
      results {
        configKey
        enabled
      }
    }
  }
`;
